import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'UNIDADE_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}
export function initForm(registro = {}) {
    return [
        initialize('unidadeForm', registro)
    ];
}

export function getLista() {
    const request = axios.get(`${consts.API_URL}/unidade`);
    return {
        type: 'UNIDADE_LISTADO',
        payload: request
    };
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/unidade`, {
				...registro,
				custo_operacao: FormatUtils.formatarValorBanco(registro.custo_operacao, 4),
				estoque_minimo_s10: FormatUtils.formatarValorBanco(registro.estoque_minimo_s10, 0),
				estoque_minimo_s500: FormatUtils.formatarValorBanco(registro.estoque_minimo_s500, 0),
				vazao_bomba_carga_s10: FormatUtils.formatarValorBanco(registro.vazao_bomba_carga_s10, 0),
				vazao_bomba_descarga_s10: FormatUtils.formatarValorBanco(registro.vazao_bomba_descarga_s10, 0),
				vazao_bomba_carga_s500: FormatUtils.formatarValorBanco(registro.vazao_bomba_carga_s500, 0),
				vazao_bomba_descarga_s500: FormatUtils.formatarValorBanco(registro.vazao_bomba_descarga_s500, 0),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/unidade`, {
				...registro,
				custo_operacao: FormatUtils.formatarValorBanco(registro.custo_operacao, 4),
				estoque_minimo_s10: FormatUtils.formatarValorBanco(registro.estoque_minimo_s10, 0),
				estoque_minimo_s500: FormatUtils.formatarValorBanco(registro.estoque_minimo_s500, 0),
				vazao_bomba_carga_s10: FormatUtils.formatarValorBanco(registro.vazao_bomba_carga_s10, 0),
				vazao_bomba_descarga_s10: FormatUtils.formatarValorBanco(registro.vazao_bomba_descarga_s10, 0),
				vazao_bomba_carga_s500: FormatUtils.formatarValorBanco(registro.vazao_bomba_carga_s500, 0),
				vazao_bomba_descarga_s500: FormatUtils.formatarValorBanco(registro.vazao_bomba_descarga_s500, 0),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/unidade?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaCidade() {
    const request = axios.get(`${consts.API_URL}/cidade/listarSelect`);
    return {
        type: 'UNIDADE_CIDADE_SELECT_LISTADO',
        payload: request
    };
}
